//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
export default {
  inheritAttrs: false,

  props: {
    title: {
      type: String,
      default() {},
    },
    subline: {
      type: String,
      default() {},
    },
    image: {
      type: Object,
      default() {},
    },
    text: {
      type: [Object, String],
      default() {},
    },
    linkText: {
      type: Object,
      default() {},
    },
    link: {
      type: Object,
      default() {},
    },
    contentType: {
      type: String,
      default: '',
      required: false,
    },
    articles: {
      type: Array,
      default() {},
    },
    reels: {
      type: Array,
      default() {},
    },
    cards: {
      type: Array,
      default() {},
    },
    items: {
      type: Array,
      default() {},
    },
    type: {
      type: String,
      default: '',
    },
    containerWidth: {
      type: String,
      default: '',
    },
    variant: {
      type: String,
      default: '',
    },
    anchorId: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      teaser: {
        title: this.title,
        image: this.image,
        text: this.text,
        link: {
          url: this.link ? this.link.url : '',
          text: this.linkText ? this.linkText.text : '',
          title: this.link ? this.link.title : '',
          linkTarget: this.link ? this.link.linkTarget : '',
          type: this.link ? this.link.type : '',
          parentPage:
            this.link && this.link.parentPage ? this.link.parentPage.slug : '',
        },
        reels: this.reels,
        cards: this.cards,
        articles: this.articles,
        subline: this.subline,
        items: this.link ? this.link.items : null,
        featuredItems: this.link ? this.link.featuredItems : null,
      },
      illustrations: [
        {
          number: 1,
          src: require(`~/assets/img/element-connect-08.svg?data`),
          width: 184,
          height: 151,
          alt: '',
        },
        {
          number: 2,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 3,
          src: require(`~/assets/img/element-learn-07.svg?data`),
          width: 157,
          height: 163,
          alt: '',
        },
        {
          number: 4,
          src: require(`~/assets/img/element-connect-06.svg?data`),
          width: 95,
          height: 143,
          alt: '',
        },
        {
          number: 5,
          src: require(`~/assets/img/element-connect-09.svg?data`),
          width: 129,
          height: 188,
          alt: '',
        },
        {
          number: 6,
          src: require(`~/assets/img/element-hear-05.svg?data`),
          width: 274,
          height: 184,
          alt: '',
        },
        {
          number: 7,
          src: require(`~/assets/img/element-learn-02.svg?data`),
          width: 157,
          height: 163,
          alt: '',
        },
        {
          number: 8,
          src: require(`~/assets/img/element-hear-03.svg?data`),
          width: 275,
          height: 262,
          alt: '',
        },
        {
          number: 9,
          src: require(`~/assets/img/element-learn-06.svg?data`),
          width: 222,
          height: 457,
          alt: '',
        },
        {
          number: 10,
          src: require(`~/assets/img/element-connect-07.svg?data`),
          width: 143,
          height: 113,
          alt: '',
        },
        {
          number: 11,
          src: require(`~/assets/img/element-learn-02.svg?data`),
          width: 119,
          height: 141,
          alt: '',
        },
      ],
    }
  },
  computed: {
    effectiveContainerWidth() {
      return this.containerWidth === null ? 'medium' : this.containerWidth
    },
    ilustrationsToShow() {
      if (this.variant === 'Articles' || this.variant === 'ArticlesGrid') {
        return this.illustrations.slice(0, 4)
      } else if (this.variant === 'Reel') {
        return this.illustrations.filter((item) =>
          [5, 8, 9].includes(item.number)
        )
      } else if (this.variant === 'Cards') {
        return this.illustrations.slice(5, 7)
      } else if (this.variant === 'HearingTests') {
        return this.illustrations.filter((item) => [1, 8].includes(item.number))
      } else if (this.variant === 'ArticleTopic') {
        return this.illustrations.filter((item) =>
          [8, 9, 10, 11, 6].includes(item.number)
        )
      } else if (this.variant === 'HearingSolution') {
        return this.illustrations.filter((item) => [1, 7].includes(item.number))
      } else {
        return []
      }
    },
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
  mounted() {},
}
